import { PayoutPreferences } from "@wingspanhq/payments/dist/interfaces";
import { MethodValue } from "../components/ManageMethods/types";

export type MethodPayoutSpeed =
  | PayoutPreferences.Standard
  | PayoutPreferences.Instant;

/**
 * `MethodValue.category` is a free-form string that the payout pickers fill
 * with the payout speed the method was selected under. This narrows it to the
 * two speeds a payout method can actually carry, so the speed can be rendered
 * alongside the method.
 */
export function selectorMethodPayoutSpeed(
  method: MethodValue
): MethodPayoutSpeed | undefined {
  if (method.category === PayoutPreferences.Standard) {
    return PayoutPreferences.Standard;
  }

  if (method.category === PayoutPreferences.Instant) {
    return PayoutPreferences.Instant;
  }

  return undefined;
}
